import React from "react";
import { Link } from "react-router-dom";
import DevOpsArticle from "../components/DevOpsArticle";
import { usePageTitle } from "../hooks/usePageTitle";

function DevOpsPage() {
  usePageTitle("DevOps & DevSecOps");
  return (
    <div className="terraform-page">
      <Link to="/blog" className="article-back-btn">← Blog</Link>
      <DevOpsArticle />
    </div>
  );
}

export default DevOpsPage;
